import React, { Component } from 'react';
import {
    withRouter
  } from 'react-router-dom'

class AppContainer extends Component {

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            document.getElementsByTagName('body')[0].scrollTop = 0;
        });
    }

    componentWillUnmount() {
        this.unlisten();
    }
    render() {
       return (
           <div>{this.props.children}</div>
        );
    }
  }
  export default withRouter(AppContainer);



// WEBPACK FOOTER //
// ./src/AppContainer.web.js